/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getSettings } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export const useGetSettings = (options?: UseQueryOptions) => {
  const queryRes = useQuery<any>({
    queryKey: userQueryKeys.userSettings,
    queryFn: getSettingsFn,
    ...options,
  });

  function getSettingsFn() {
    return getSettings()
      .then((res) => {
        const { data } = res;
        if (data?.dashboard_widgets?.length) {
          // TODO: temporary removed until the query is fixed
          data.dashboard_widgets = data.dashboard_widgets.filter((widget: any) => widget.content !== "At risk for cancel");
        }
        return Promise.resolve(data);
      })
      .catch((err) => Promise.reject(err));
  }

  return queryRes;
};
